import { render } from "./IndexMenu.vue?vue&type=template&id=d509cf44&scoped=true&ts=true"
import script from "./IndexMenu.vue?vue&type=script&lang=ts"
export * from "./IndexMenu.vue?vue&type=script&lang=ts"

import "./IndexMenu.vue?vue&type=style&index=0&id=d509cf44&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d509cf44"]])

export default __exports__